<script>
export default {
  props: {
    showLogo: {
      type: Boolean,
      default: false
    },
    logoName: {
      type: String,
      default: "icons_12pt_right.png"
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    maxlength: {
      type: [Number],
      default: 50
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    errTips: {
      type: String,
      default: ''
    },
    isShowError: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: true,
    },
    valueStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    borderType: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      hasFocus: false,
      clickTimeout: null
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value
      },
      set: function (val) {
        this.$emit('input', val)
      }
    },
    className() {
      let list = [];
      this.showSeparator && list.push('border');
    }
  },
  methods: {
    focus() {
      this.$refs.refInput && this.$refs.refInput.focus()
    },
    clear() {
      this.$emit('input', '')
      this.$emit('clear')
    },

    _focus() {
      this.hasFocus = true
      this.$emit('focus', '')
    },
    _blur() {
      this.$emit('blur', '')
      setTimeout(() => {
        this.hasFocus = false
      }, 300)
    },
    _handleClick() {
      this.clickTimeout =setTimeout(() => {
        if (!this.edit) {
          this.$toast(this.$t('Unmodifiable'))
        } else {
          this.$emit('click')
        }
      }, 100)
    },
  },
  beforeDestroy() {
    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout)
    }
  }
}

</script>

<template>
<div class="hs-section-cell" :class="{border: showSeparator, error: isShowError}" @click="_handleClick">
  <div class="label" v-if="title">
    <div class="text">
      <span v-if="required" class="required"></span>{{title}}
    </div>
    <div v-if="subtitle" class="subtitle">
      <div v-if="required" style="width: 10px"></div>
      {{subtitle}}
    </div>
  </div>
  <div class="right">
    <div class="value">
      <slot name="valuePrefix"></slot>
      <slot>
        <div v-if="!edit" class="text" :class="[value ? 'gray1' : 'unEdit gray']" :style="valueStyle">{{value || placeholder}}</div>
        <input
            ref="refInput"
            v-else-if="type === 'input'"
            class="text"
            v-model.trim="currentValue"
            :maxlength='maxlength'
            :placeholder="placeholder"
            @focus="_focus"
            @blur="_blur"
        >
        <div v-else class="text" :style="valueStyle" :class="{gray: !value}">{{value || placeholder}}</div>
      </slot>
      <div
          v-if="edit && clearable && hasFocus && (currentValue || currentValue === 0)"
          class="logo clear"
          @click.stop="edit && clear()"
          :style="{backgroundImage: `url(${require('@/assets/image/base/close/icons_24pt_close.svg')})`}"
      ></div>
      <slot name="logo">
        <div v-if="edit && showLogo" class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/' + logoName)})`}"></div>
      </slot>
    </div>
    <span v-if="errTips" class="tips">{{errTips}}</span>
  </div>
</div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-section-cell{
  @extend .flex-start;
  @extend .hs-font-body;
  align-items: flex-start;
  width: 100%;
  min-height: 56px;
  padding: 8px 16px;
  word-break: break-all;
  &.border{
    >.right{
      >.value{
        border-bottom: 0.5px solid $color_black_30;
      }
    }
  }
  &.error{
    >.right{
      >.value{
        border-bottom: 1px solid $color_red_300;
        >.text::placeholder{
          color: $color_red_300 !important; // 有值时的文字颜色
        }
        >.gray{
          color: $color_red_300;
          &.unEdit{
            color: $color_red_75;
          }
        }
      }
    }
  }
  >.label{
    @extend .flex-start;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    flex-shrink: 0;
    color: $color_black_300;
    width: 81px;
    min-height: 38px;
    padding-right: 8px;
    >.text{
      @extend .flex-start;
      align-items: baseline;
      >.required{
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        background-image: url(@/assets/image/base/cell/required.png);
        background-size: 100% 100%;
        margin: 5px 0;
      }
    }
    >.subtitle{
      @extend .flex-start;
      @extend .hs-font-caption-1;
    }
  }
  >.right{
    width: 100%;
    >.value{
      @extend .flex-start;
      width: 100%;
      min-height: 38px;
      padding: 5px 0;
      >.text{
        width: 100%;
        font-weight: 400;
        min-height: 28px;
        padding: 4px 0;
        caret-color: $color_red_300;
        &::placeholder{
          color: $color_black_50;
          font-weight: 400;
        }
      }
      >.gray{
        color: $color_black_50;
        font-weight: 400;
      }
      >.gray1{
        color: $color_black_100;
        font-weight: 400;
      }
      >.logo{
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background-size: 100% 100%;
      }
      >.clear{
        width: 24px;
        height: 24px;
      }
    }
    >.tips{
      @extend .hs-font-caption-1;
      display: flex;
      color: $color_red_300;
    }
  }
}
</style>
